import './style.css'

import App from './App.vue'
import { i18nModule } from '@/modules/i18n'
import { ViteSSG } from 'vite-ssg'
import { routes } from 'vue-router/auto-routes'

export const createApp = ViteSSG(App, { routes }, ({ app, router }) => {
  app.use(i18nModule)

  router.options.scrollBehavior = (to, _from, savedPosition) => {
    if (savedPosition) {
      return savedPosition
    }

    if (to.hash) {
      return {
        el: to.hash,
        top: 40,
        behavior: 'smooth',
      }
    }

    return { top: 0 }
  }
})
